import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('catalog-side-navigation', () => import(/* webpackMode: "lazy" */'./catalog-side-navigation'));
